import { render, staticRenderFns } from "./RouteInfo.vue?vue&type=template&id=824cfe76&scoped=true&"
import script from "./RouteInfo.vue?vue&type=script&lang=ts&"
export * from "./RouteInfo.vue?vue&type=script&lang=ts&"
import style0 from "./RouteInfo.vue?vue&type=style&index=0&id=824cfe76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824cfe76",
  null
  
)

export default component.exports